<template>
	<div class="hello">
		<div class="sign" @scroll="getScro" ref="sign">
			<div class="sign_titl">
				<span>{{$t('language.Registration')}}</span>
			</div>
			<div class="line"></div>
			<div class="sign_text" v-if="formList.length > 0">
				<span v-html="onlineInfo"></span>
			</div>
			<div class="sign_form isa" style="border-bottom: none;">
				<div class="sign_t " v-if="formList.length > 0">
					必填
				</div>
				<div class="sign_tit">
					<span v-if="lang == 'cn'">报名类型</span>
					<span v-else>Registration type</span>
				</div>
				<div class="sign_type" v-if="formList.length > 0">
					<el-form :model="form">
							<el-select v-model="form.region" :placeholder="$t('language.signType')" @change="selectChange">
								<el-option v-for="(item,index) in optios" :key="index" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
					</el-form>
				</div>
			</div>
			<div class="sign_form" v-for="(item,index) in formList" :key="index">
				<div class="sign_t " v-if="item.is_required == 1">
					必填
				</div>
				<div class="sign_t " v-if="item.is_required == 0">
					选填
				</div>
				<div class="sign_tit">
					<span v-if="lang == 'cn'">{{item.field_title}}</span>
					<span v-else>{{item.field_title_en}}</span>
				</div>
				<div class="sign_type" v-if="item.field_type == 'select'">
					<el-select v-model="item.field_value" clearable :placeholder="$t('language.place')">
						<el-option v-for="(ite,index) in item.field_option" :key="index" :label="ite" :value="ite">
						</el-option>
					</el-select>
				</div>
				<div class="sign_type" v-if="item.field_type == 'input'">
					<el-input v-model="item.field_value"></el-input>
				</div>
				<div class="sign_type" style="padding-top:15px;padding-left: 15px;"
					:class="{textare:item.field_type == 'textarea'}" v-if="item.field_type == 'textarea'">
					<textarea rows="3" v-model="item.field_value" cols="20">
                   </textarea>
				</div>
				<div class="sign_type" :class="{audios:item.field_type == 'radio'}" v-if="item.field_type == 'radio'">
					<div class="audio">
						<el-radio v-model="item.field_value" v-for="(ite,ind) in item.field_option" :key="ind"
							:label="ite">{{ite}}</el-radio>

					</div>
				</div>
				<div class="sign_type" :class="{audios:item.field_type == 'checkbox'}"
					v-if="item.field_type == 'checkbox'">
					<div class="audio">
						<el-checkbox :label="values" v-for="(ite,ind) in item.field_option" :key="ind"
							@change="change($event,item,ind,index)">{{ite}}</el-checkbox>
					</div>
				</div>
				<div class="sign_type" v-if="item.field_type == 'date'">
					<el-date-picker v-model="item.field_value" type="date" @change="dateChange($event,item,index)"
						:placeholder="$t('language.date')">
					</el-date-picker>
				</div>
				<input ref="aa" type="file" class="uploads-file" @change="getFile" style="display: none;">
				<div v-if="item.field_type == 'image'">
					<div class="upoadImas" v-if="uploadImage != ''" @click="uploadHead">
						<img :src="uploadImage" alt="">
					</div>
					<div class="upoadImas" v-else @click="uploadHead">
						<img :src="lang == 'cn' ? uploadImg : uploadEn" alt="">
					</div>
				</div>
				<input ref="filElem" multiple type="file" class="upload-file" @change="uploadChange"
					style="display: none;">
				<div class="is_set" v-if="item.field_type == 'single'">
					<!-- <el-upload action="https://jsonplaceholder.typicode.com/posts/" list-type="picture-card">
                    <i class="el-icon-plus"></i>
                  </el-upload> -->
					<div class="imgList" v-if="it" v-for="(it,ins) in singles" :key="ins">
						<img :src="it" alt="">
						<div class="close" @click="closeEvent(ins)">
							<img src="../assets/image/close.png" alt="">
						</div>
					</div>
					<div class="imageList" @click="uploadEvent">
						<img src="../assets/image/add.png" alt="">
					</div>


				</div>

				<input ref="FILE" type="file" multiple class="upload-file" @change="uploadVideo" style="display: none;">
				<div class="is_set" v-if="item.field_type == 'video'">
					<div class="imgList" v-if="it" v-for="(it,ins) in single" :key="ins">
						<video style="width: 100%;height: 100%;" :src="it.file_path" controls></video>
						<div class="close" @click="closeVideo(ins)">
							<img src="../assets/image/close.png" alt="">
						</div>
					</div>
					<div class="imageList" @click="uploadVide">
						<img src="../assets/image/add.png" alt="">
					</div>
				</div>
				<div class="is_set" v-if="item.field_type == 'multiple'">
					<div class="listT" v-for="(item,index) in tablist" :key="index" @click="photoEvent(item.id,item)">
						<span>{{item.name}}</span>
						<div class="closeTab" @click.stop="closeEven(index,item.id)">
							<img src="../assets/image/close.png" alt="">
						</div>
					</div>
					<div class="addTab" @click="addphoto">
						<span>{{$t('language.add')}}</span>
					</div>
				</div>
				<div class="clear"></div>
			</div>
			<div class="jianjie">
				<span>
					1.{{$t('language.exhibition')}}
					<br />
					2.{{$t('language.Please')}}
					<br />
					3.{{$t('language.version')}}
					<br />
					4.{{$t('language.materials')}}
					<br />
					5.{{$t('language.group')}}
				</span>
			</div>
			<div class="submitSign">
				<div class="leftSub" @click="storage">
					<span>{{$t('language.storage')}}</span>
				</div>
				<div class="rightSub" @click="submit">
					<span>{{$t('language.submit')}}</span>
				</div>
			</div>
			<div style="height: 200px;"></div>
		</div>
		<el-dialog :modal-append-to-body="false" :title="$t('language.type')" :closeOnClickModal="false"
			:visible.sync="dialogFormVisible">
			<el-form :model="form">
				<el-form-item :label="$t('language.signType')" :label-width="formLabelWidth">
					<el-select v-model="form.region" :placeholder="$t('language.signType')" @change="selectChange">
						<el-option v-for="(item,index) in optios" :key="index" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="goHome">{{$t('language.Back')}}</el-button>
				<el-button type="primary" @click="ajaxFun">{{$t('language.Confirm')}}</el-button>
			</div>
		</el-dialog>
		<fiex :shows="fixed" :fatherMethod="goTop"></fiex>
		<div style="height: 100px;"></div>
		<div class="footerTitle" v-if="footerShow">
			<div class="title_center">
				<div class="listB" style="padding-top: 4px;padding-bottom: 4px;">
					<a href='https://218.26.86.27:8067/ei/Ei!certificate.action?id=9028ffb17604406e01761864b3aa0010' target='_blank' style='border:0;height: 59px;'><img src='../assets/image/shichang.png' style='border:0;height: 100%;width: 100%;'/></a>
				</div>
				<div class="listB">
					<span>{{$t('language.address_b')}}：{{address}}</span>
				</div>
				<div class="listB">
					<span>{{$t('language.emails')}}:{{email}}</span>
				</div>
				<div class="listB">
					<span>ICP备：晋ICP备13002558号-2</span>
				</div>
			</div>
		</div>
		<addphotographer :exhibitionid="id" :details="details" :dataList='dataList' :isFlag="false"
			:isEditPhotographer='isEditPhotographer' :uploadList="uploadList" :addShow="addS" @parentShow="showData"
			@baseData="baseEvent"></addphotographer>
		<!-- 添加摄影师 -->
	</div>

</template>

<script>
	import fiex from '../components/fiex.vue'
	import addphotographer from '../components/addphotographer'
	export default {
		components: {
			addphotographer,
			fiex
		},
		data() {
			return {
				fixed: false,
				addShow: true,
				addS: false,
				input: '',
				checked1: '',
				details: {
					audit_status: 2
				},
				checked2: '',
				imageUrl: '',
				uploadImg: require('../assets/image/upload.png'),
				uploadEn: require('../assets/image/uploadEn.png'),
				footerShow: false,
				uploadImage: '',
				imgList: [],
				values: [],
				options: [{
					value: '选项1',
					label: '黄金糕'
				}, {
					value: '选项2',
					label: '双皮奶'
				}, {
					value: '选项3',
					label: '蚵仔煎'
				}, {
					value: '选项4',
					label: '龙须面'
				}, {
					value: '选项5',
					label: '北京烤鸭'
				}],
				value: '',
				formList: [],
				tablist: [],
				dataList: {},
				isEditPhotographer: false,
				form: {
					name: '',
					region: '',
					date1: '',
					date2: '',
					delivery: false,
					type: [],
					resource: '',
					desc: ''
				},
				uploadList: '',
				obj: {
					name: '张三'
				},
				dialogFormVisible: true,
				formLabelWidth: '120px',
				id: '',
				optios: [],
				single: [],
				flag: true,
				jiaoyan: '',
				jiaoyanP: '',
				jiaoyanE: '',
				address: '',
				email: '',
				lang: 'cn',
				singles: [],
				onlineInfo:''
			}
		},
		created() {
			if (localStorage.getItem('languageSet') == 'en') {
				this.lang = 'cn'
			} else {
				this.lang = 'en'
			}
			var that = this;
			var flag = false;
			this.$fetch('/index/info').then(res => {
				this.address = res.data.address;
				this.email = res.data.email;

			})

			this.$post('/Apply/getId').then(res => {
				that.id = res.data.id;

			})

			// if(!localStorage.getItem('access_token') ) {
			//       this.$router.push('/')
			//   }

			this.$fetch('/Apply/exhibitionCategoryList').then(res => {
				this.optios = res.data;
			})

		},
		mounted() {
			// console.log(localStorage.getItem('access_token'));
			if (!localStorage.getItem('access_token')) {
				this.$message.error(this.$t("language.onLogin"))
				this.$router.push('/')
			}
			this.getOnlineInfo();
		},
		methods: {
			
			getOnlineInfo(){
				let that = this;
				this.$fetch('/Content/getOnlineApplyInstruction').then(res => {
					console.log(res.data.info)
					that.onlineInfo = res.data.info;
				})
			},
			goTop() {
				this.$refs.sign.scrollTop = 0;
			},
			getScro() {
				var scrollTop = document.documentElement.scrollTop || document.body.scrollTop || this.$refs.sign
					.scrollTop ||
					window.pageYOffset;
				console.log(scrollTop)
				if (scrollTop > 20) {
					this.fixed = true;
				} else {
					this.fixed = false;
				}

				let scrollBottom =
					event.target.scrollHeight -
					event.target.scrollTop -
					event.target.clientHeight;
				if (scrollBottom <= 0) {
					this.footerShow = true;
				} else {
					this.footerShow = true;
				}
			},
			change(e, item, index, inde) {
				console.log(inde)
				var data = item.field_option;
				if (e) {
					this.values.push(data[index]);
					if (!this.formList[inde].field_value) {
						this.formList[inde].field_value = [];
					}
					this.formList[inde].field_value.push(data[index])

				} else {
					this.values.splice(index, 1);
				}

			},
			dateChange(e, item, index) {
				console.log(e.getDate())
				const resDate = e.getFullYear() + '-' + (e.getMonth() + 1 < 10 ? '0' +( e.getMonth() + 1) : e.getMonth() + 1) + '-' + (e.getDate() < 10 ? '0' + e.getDate() : e.getDate())
				console.log(resDate);
				item.field_value = resDate;
			},
			selectChange() {
				console.log(this.form.region);
				this.ajaxFun()
			},
			goHome() {
				this.$router.push('/')
			},
			getFile(el) {
				var file = el.target.files[0];
				var blob = new Blob([file]);
				// var fileSize = 0;
				// var fileMaxSize = 1024; //1M
				// var fileSize = file.size;
				// var size = fileSize / 1024;
				// if (size > fileMaxSize) {
				//   console.log('25545')
				//   this.$message.error('文件不能大于1M')
				//   return false
				// }
				const blobUrl = window.URL.createObjectURL(blob);


				let formData = new FormData();
				formData.append("file", file);
				var data = formData;
				this.$post('/Upload/image', data).then(res => {
					if (res.code == 200) {
						this.formList.forEach(item => {
							if (item.field_type == 'image') {
								item.field_value = res.data.file_path;
								this.uploadImage = blobUrl;
							}
						})
					}

				})
				el.target.value = '';
			},
			uploadChange(el) {
				console.log(el);
				var file = el.target.files;
				for (var i = 0; i < file.length; i++) {
					console.log(file[i])
					var blob = new Blob([file[i]]);
					let formData = new FormData();
					formData.append("file", file[i]);
					const blobUrl = window.URL.createObjectURL(blob);
					var data = formData;
					this.$post('/Upload/image', data).then(res => {
						if (res.code == 200) {
							this.single.push(res.data)
							this.singles.push(blobUrl)
						}
					})
				}

				// var fileSize = 0;
				// var fileMaxSize = 1024; //1M
				// var fileSize = file.size;
				// var size = fileSize / 1024;
				// if (size > fileMaxSize) {
				//   console.log('25545')
				//   this.$message.error('文件不能大于1M')
				//   return false
				// }

				return;

			},
			closeVideo(index) {
				this.single.splice(index, 1);
			},
			addphoto() {
				this.isEditPhotographer = false;
				this.addS = true;
			},
			showData(data) {
				this.addS = data;
			},
			uploadHead() {
				this.$refs.aa[0].dispatchEvent(new MouseEvent('click'))
			},
			storage() {
				console.log(this.formList);
				var data = JSON.stringify(this.formList);
				console.log(data);
				console.log(this.id);
				var flag;
				this.formList.forEach(item => {
					if (item.field_name == 'single') {
						flag = 'single'
					} else if (item.field_name == 'multiple') {
						flag = 'multiple'
					}
				})
				var dat = {
					id: this.id,
					ex_field_list: data,
					photographer_type: flag,
					audit_status: -1,
					exhibition_category_id: this.form.region,
					single: JSON.stringify(this.single)
				}
				this.$post('/Apply/save', dat).then(res => {
					if (res.code == 200) {
						this.$message.success('暂存成功')
						this.$router.push('/personal')
					}
				})
			},
			submit() {
				let flag = 'single';
				var aa = true;
				var idcard = '';
				var phone = '';
				var email = '';
				this.formList.forEach(item => {
					if (item.field_type == 'input') {
						if (!item.field_value) {
							aa = false;
						} else {
							aa = true;
						}
					}
					if (item.field_type == 'single') {
						if (this.single.length <= 0) {
							aa = false;
						} else {
							aa = true;
						}
					}
					if (item.field_name == 'single') {
						flag = 'single'
					} else if (item.field_name == 'multiple') {
						flag = 'multiple'
					}
					if (item.field_name == 'idcard') {
						this.jiaoyan = 'idcard'
						idcard = item.field_value;
					}
					if (item.field_name == 'phone') {
						this.jiaoyanP = 'phone';
						phone = item.field_value;
					}
					if (item.field_name == 'email') {
						this.jiaoyanE = 'email';
						email = item.field_value;
					}
				})
				// if (this.jiaoyan == 'idcard') {
				//   var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
				//   if (reg.test(idcard) === false) {
				//     this.$message.error(this.$t('language.idcardError'));
				//     return false;
				//   }
				// }
				// if (this.jiaoyanP == 'phone') {
				//   if (!(/^1[3456789]\d{9}$/.test(phone))) {
				//     this.$message.error(this.$t('language.phoneError'));
				//     return false;
				//   }
				// }
				// if (this.jiaoyanE == 'email') {
				//   var t = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9-])+((\.[a-zA-Z0-9-]{2,3}){1,2})$/;
				//   if (!(t.test(email))) {
				//     this.$message.error(this.$t('language.EmailError'))
				//     return false
				//   }
				// }
				// if (!aa) {
				//   this.$message.error(this.$t('language.successMessage'));
				//   return
				// }
				this.formList.forEach(item => {
					if (item.field_name == 'single') {
						item.field_value = this.single;
					}
				})
				var lang = 'cn'
				var langSet = window.localStorage.getItem('languageSet');
				if(langSet == 'zh'){
					lang = 'en'
				}else{
					lang = 'cn'
				}
				// 校验参数是否为空
				var string = '';
				
				for(var i = 0; i < this.formList.length; i++){
					if(this.formList[i].is_required == 1){
						if(!this.formList[i].field_value){
							if(lang == 'cn'){
								string = this.formList[i].field_title;
							}else{
								string = this.formList[i].field_title_en;
							}
							break; // 如果参数为空 跳出循环 提示
						}
					}
				}
				
				if(string != ''){
					if(lang == 'cn'){
						this.$message.error(`${string}不能为空`);
					}else{
						this.$message.error(`${string}Cannot be empty`);
					}
					return
				}
				var data = JSON.stringify(this.formList);
				var dat = {
					id: this.id,
					exhibition_category_id: this.form.region,
					ex_field_list: data,
					photographer_type: flag,
					audit_status: 0,
					// single: JSON.stringify(this.single)
				}
				this.$post('/Apply/save', dat).then(res => {
					if (res.code == 200) {
						this.$router.push({
							path: '/personal'
						})
					}
				})
			},
			baseEvent(data) {
				this.tablist = data;
				this.formList.forEach(item => {
					if (item.field_type == 'multiple') {
						item.field_value = '1';
					}
				})
			},
			photoEvent(id, item) {
				var data = {
					id: id
				}
				this.$post('/Apply/photographerDetail', data).then(res => {
					this.dataList = res.data;
					this.isEditPhotographer = true;
				})
				this.addS = true;
			},
			mouseOver() {
				this.addShow = false;
			},
			mouseOut() {
				this.addShow = true;
			},
			uploadEvent() {
				this.$refs.filElem[0].dispatchEvent(new MouseEvent('click'))
			},
			uploadVide() {
				console.log(this.$refs.FILE);
				this.$refs.FILE[0].dispatchEvent(new MouseEvent('click'))
			},
			uploadVideo(el) {
				var file = el.target.files;
				var flag = false;
				for (var i = 0; i < file.length; i++) {
					if (file[i].type == 'video/mp4') {
						let formData = new FormData();
						formData.append("file", file[i]);
						var data = formData;
						this.$post('/Upload/video', data).then(res => {
							this.single.push(res.data)
						})
					} else {
						flag = true;
					}
				}
				if (flag) {
					this.$message.error(this.$t('language.uploadVideo'))
					return
				}

				el.target.value = '';
				// var blob = new Blob([file]);
				// var fileSize = 0;
				// var fileMaxSize = 1024; //1M
				// var fileSize = file.size;
				// var size = fileSize / 1024;


				// const blobUrl = window.URL.createObjectURL(blob);
				// this.imgList.push(blobUrl)


			},
			closeEvent(index) {
				this.singles.splice(index, 1);
				this.single.splice(index, 1);
			},
			closeEven(index, id) {
				this.tablist.splice(index, 1)
				this.$fetch('/Apply/delPhotographer', {
					id: id
				}).then(res => {
					if (res.code == 200) {
						this.$message.success('删除成功')
					}
				})
			},

			ajaxFun() {

				if (this.form.region != '') {
					this.dialogFormVisible = false;
					this.$post('/Temp/list', {
							"exhibition_category_id": this.form.region
						}).then(res => {
							console.log(res.data)
							this.flag = false;
							this.formList = res.data;
							this.formList[0].isActive = true;
							this.dialogFormVisible = false;
							for (var i = 0; i < this.formList.length; i++) {
								if (this.formList[i].field_type == 'single_photographer') {
									this.formList[i].field_title = '上传照片'
								}
								if (this.formList[i].field_type == 'multi_photographer') {
									this.formList[i].field_title = '参展人员'
								}
							}
						})
						.catch(err => {
							console.log(err)
						})
				} else {
					this.$message.error(this.$t('language.sign_type'))
				}
			}
		}
	}
</script>
<style scoped="scoped">
	@import url("../assets/css/sign.css");
</style>



// WEBPACK FOOTER //
// src/pages/sign.vue